import React, { useEffect, useRef } from 'react';
import styles from './AuraLogo.module.scss';
import CanvasParticles from './CanvasParticles';
import logo from '@app/img/settings/aura.png';
import logoBlue from '@app/img/settings/aura_blue.png';
import logoLight from '@app/img/settings/aura-light.png';
import logoLightBlue from '@app/img/settings/aura-light_blue.png';
import { useSelector } from 'react-redux';
import { selectAuraSettings } from '@repo/redux/reducers/user/aura';
import { useTheme } from '@repo/themes';
import { CSSTransition } from 'react-transition-group';

export default function AuraLogo() {
  const auraSettings = useSelector(selectAuraSettings);
  const [theme] = useTheme();
  const canvasRef = useRef(null);
  const particles = useRef(null);
  const defaultLogo = theme === 'light' ? logoLightBlue : logoBlue;
  const enabledLogo = theme === 'light' ? logoLight : logo;

  useEffect(() => {
    const width = canvasRef.current.offsetWidth * 2;
    const height = canvasRef.current.offsetHeight * 2;
    canvasRef.current.width = width;
    canvasRef.current.height = height;
    particles.current = new CanvasParticles(canvasRef.current);

    return () => {
      particles.current.stop();
      particles.current = undefined;
    };
  }, []);
  return (
    <div className={styles.logoContainer}>
      <canvas className={styles.particles} ref={canvasRef} />
      <CSSTransition
        in={!auraSettings.is_enabled}
        classNames={{
          enter: styles.logoEnter,
          enterActive: styles.logoEnterActive,
          exit: styles.logoExit,
          exitActive: styles.logoExitActive,
        }}
        timeout={150}
        unmountOnExit
      >
        <img className={styles.logo} src={defaultLogo} alt="Aura Logo" />
      </CSSTransition>
      <CSSTransition
        in={auraSettings.is_enabled}
        classNames={{
          enter: styles.logoEnter,
          enterActive: styles.logoEnterActive,
          exit: styles.logoExit,
          exitActive: styles.logoExitActive,
        }}
        timeout={150}
        unmountOnExit
      >
        <img className={styles.logo} src={enabledLogo} alt="Aura Logo" />
      </CSSTransition>
      <svg
        className={styles.svgFilter}
        width="72"
        height="72"
        viewBox="0 0 144 144"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="displacementFilter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.04"
              numOctaves="34"
              result="turbulence"
              seed="2"
            >
              <animate
                id="noiseAnimate"
                attributeName="baseFrequency"
                values="0.04;0.06;0.04,0.04"
                from="0"
                to="100"
                dur="11s"
                repeatCount="indefinite"
              ></animate>
            </feTurbulence>
            <feColorMatrix in="turbulence" type="hueRotate" values="" result="cloud">
              <animate attributeName="values" from="0" to="360" dur="2s" repeatCount="indefinite" />
            </feColorMatrix>
            <feDisplacementMap
              in2="cloud"
              in="SourceGraphic"
              scale="4"
              xChannelSelector="G"
              yChannelSelector="R"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}
